var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main_bg" }, [
    _c("img", {
      staticClass: "main_img",
      attrs: { src: require("@/assets/404_images/main.png"), alt: "404" },
    }),
    _vm._v(" "),
    _c("p", { staticClass: "title" }, [_vm._v("404 Error")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "btn", on: { click: _vm.goHome } }, [
      _vm._v("Home Page"),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "des" }, [
      _c("p", [_vm._v("Sorry, the page you are looking for does not exist. ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Try to check the URL for errors and then press the refresh button on the browser"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("or try to find something else in our application.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }